import {SelectedRoom} from './types';
import {
  // TYPE SCRIPT TYPES
  DetailStaticShape,
  DetailsHermesShape,
  SelectedRoomDataType,
  IUpdate_Details_Config_Action,
  IResetDetailsData,
  ACTION_UPDATE_HOTEL_POLICY_LIST,
  ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
  ACTION_UPDATE_HOTEL_POLICY_ERROR,
  DetailsStateShape,
  FetchStatusType,
  ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS,
  ACTION_UPDATE_DETAILS_OPEN_CATEGORIZED_AMENITIES,
} from './types';

import {
  RESET_DETAILS_DATA,
  UPDATE_DETAILS_STATIC_FETCH_STATUS,
  UPDATE_DETAILS_HERMES_FETCH_STATUS,
  UPDATE_DETAILS_STATIC_DATA,
  UPDATE_DETAILS_HERMES_DATA,
  UPDATE_CURRENT_ROOM,
  UPDATE_DETAILS_CONFIG,
  UPDATE_UGC_IMAGES,
  UPDATE_ABOUT_PROPERTY,
  UPDATE_HOTEL_POLICY_LIST,
  UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
  UPDATE_HOTEL_POLICY_ERROR,
  UPDATE_HOTEL_POLICY_FETCH_STATUS,
  UPDATE_SIMILAR_HOTELS_DATA,
  UPDATE_SIMILAR_HOTELS_ERROR,
  UPDATE_SIMILAR_HOTELS_FETCH_STATUS,
  UPDATE_SAFETY_HYGIENE_MEDIA_DATA,
  UPDATE_SELECTED_ROOM_DATA,
  RESET_SELECTED_ROOM_DATA,
  UPDATE_OPEN_CATEGORIZED_AMENITIES,
  UPDATE_STATIC_DATA_FETCH_STATUS,
} from './constants';

// 🐨 no use typing voyager data because dynamic data wouldn't be type checked
// 🐨 leaving it as 'any' for now, and will progressively add the types for
// front end engineer's convenience
export const updateDetailsStaticData = (staticData: DetailStaticShape) => {
  return {
    type: UPDATE_DETAILS_STATIC_DATA,
    payload: {
      staticData,
    },
  };
};

export const updateUgcImages = actionData => {
  return {
    type: UPDATE_UGC_IMAGES,
    actionData,
  };
};

export const updateAboutPropertyData = actionData => {
  return {
    type: UPDATE_ABOUT_PROPERTY,
    actionData,
  };
};

// 🐨 leaving it as 'any' for now, and will progressively add the types for
// front end engineer's convenience
export const updateDetailsHermesData = (hermesData: DetailsHermesShape) => {
  return {
    type: UPDATE_DETAILS_HERMES_DATA,
    payload: {
      hermesData,
    },
  };
};

export const updateDetailsStaticFetchStatus = ({isLoading}: {isLoading: boolean}) => {
  return {
    type: UPDATE_DETAILS_STATIC_FETCH_STATUS,
    payload: {
      isLoading,
    },
  };
};

// For Mweb , going forward will be used for dWeb too, not the above one (to maintain it at a single place).
export const updateStaticDataFetchStatus = staticDataStatus => {
  return {
    type: UPDATE_STATIC_DATA_FETCH_STATUS,
    payload: {
      staticDataStatus,
    },
  };
};

/**
 * @Backlog
 * 🦢this is legacy and should be removed. If there are any instance in details dweb, that should be refactored
 */
export const updateCurrentRoom = (roomData: SelectedRoomDataType) => {
  return {
    type: UPDATE_CURRENT_ROOM,
    payload: {
      roomData,
    },
  };
};

export const updateDetailsHermesFetchStatus = ({isLoading}: {isLoading: boolean}) => {
  return {
    type: UPDATE_DETAILS_HERMES_FETCH_STATUS,
    payload: {
      isLoading,
    },
  };
};

export const updateDetailsOpenCategorizedAmenities = ({
  OpenCategorizedAmenities,
}: {
  OpenCategorizedAmenities: boolean;
}) => {
  return {
    type: UPDATE_OPEN_CATEGORIZED_AMENITIES,
    payload: {
      OpenCategorizedAmenities,
    },
  };
};

export const updateDetailsPageConfigAction = (
  actionData: IUpdate_Details_Config_Action['actionData'],
): IUpdate_Details_Config_Action => {
  return {
    type: UPDATE_DETAILS_CONFIG,
    actionData,
  };
};

export const resetDetailsData = (): IResetDetailsData => {
  return {
    type: RESET_DETAILS_DATA,
  };
};

export const updateHotelPolicyFetchStatus = (
  status: FetchStatusType,
): ACTION_UPDATE_HOTEL_POLICY_FETCH_STATUS => {
  return {
    type: UPDATE_HOTEL_POLICY_FETCH_STATUS,
    payload: {
      hotelPolicyFetchStatus: status,
    },
  };
};

export const updateHotelPolicyList = (
  hotelPolicyList: DetailsStateShape['hotelPolicyData']['hotelPolicyList'],
): ACTION_UPDATE_HOTEL_POLICY_LIST => {
  return {
    type: UPDATE_HOTEL_POLICY_LIST,
    payload: {
      hotelPolicyList,
    },
  };
};

export const updateHotelPolicyAdditionalData = (
  hotelPolicyAdditionalData: DetailsStateShape['hotelPolicyData']['hotelPolicyAdditionalData'],
): ACTION_UPDATE_HOTEL_POLICY_ADDITIONAL_DATA => {
  return {
    type: UPDATE_HOTEL_POLICY_ADDITIONAL_DATA,
    payload: {
      hotelPolicyAdditionalData,
    },
  };
};

export const updateHotelPolicyError = (error: Error): ACTION_UPDATE_HOTEL_POLICY_ERROR => {
  return {
    type: UPDATE_HOTEL_POLICY_ERROR,
    payload: {
      hotelPolicyError: error,
    },
  };
};

export const updateSimilarHotels = ({list, cityMetaInfo}) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_DATA,
    payload: {
      list,
      cityMetaInfo,
    },
  };
};

export const updateSimilarHotelsError = (error: Error) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_ERROR,
    payload: {
      error,
    },
  };
};

export const updateSimilarHotelsFetchStatus = (fetchStatus: FetchStatusType) => {
  return {
    type: UPDATE_SIMILAR_HOTELS_FETCH_STATUS,
    payload: {
      fetchStatus,
    },
  };
};

export const updateSafetyHygieneMediaData = (actionData = []) => {
  return {
    type: UPDATE_SAFETY_HYGIENE_MEDIA_DATA,
    actionData,
  };
};

export const updateSelectedRoomData = (selectedRoomData: SelectedRoom) => {
  return {
    type: UPDATE_SELECTED_ROOM_DATA,
    payload: {
      selectedRoomData,
    },
  };
};

export const resetSelectedRoomData = () => {
  return {type: RESET_SELECTED_ROOM_DATA};
};
